import { ReactNode } from 'react';
import { RachelProductCardsTestIds } from '../../../../../../../utils/testIds/RachelProductCards.testIds';
import ProductGalleryNavButtons from '../../../../../../products/details/gallery/components/ProductGalleryNavButtons/ProductGalleryNavButtons';
import { useProductCardsCarouselStyles } from './productCardsCarousel.styles';
import { useProductCardsCarousel } from './useProductCardsCarousel';

interface ProductCardsCarouselProps {
  label: string;
  children: ReactNode;
}

const ProductCardsCarousel = ({ label, children }: ProductCardsCarouselProps) => {
  const {
    containerRef,
    startSentinelRef,
    endSentinelRef,
    isStartReached,
    isEndReached,
    navTop,
    scrollPrevious,
    scrollNext,
  } = useProductCardsCarousel();
  const { classes, cx } = useProductCardsCarouselStyles({ navTop });

  return (
    <div className={classes.root}>
      <div
        ref={containerRef}
        role="list"
        aria-label={label}
        test-id={RachelProductCardsTestIds.CAROUSEL}
        className={classes.track}
      >
        <div ref={startSentinelRef} aria-hidden className={classes.startSentinel} />
        {children}
        <div ref={endSentinelRef} aria-hidden className={classes.endSentinel} />
      </div>
      <div
        aria-hidden
        className={cx(
          classes.edge,
          classes.fade,
          classes.fadeStart,
          isStartReached && classes.edgeHidden,
        )}
      />
      <div
        aria-hidden
        className={cx(
          classes.edge,
          classes.fade,
          classes.fadeEnd,
          isEndReached && classes.edgeHidden,
        )}
      />
      <ProductGalleryNavButtons
        className={classes.nav}
        isPreviousHidden={isStartReached}
        isNextHidden={isEndReached}
        onPrevious={scrollPrevious}
        onNext={scrollNext}
      />
    </div>
  );
};

export default ProductCardsCarousel;
